import {currency, tax} from '../globals/config';
import {serviceDescriptionData} from './serviceDescription';
import {apSwitchStep} from '../../appointment-tool/components/apSwitchStep';
import {serviceSelectorData} from '../../appointment-tool/modules/serviceSelector';
import {menaPrice} from '../../components/tools';
import apAnalytics from '../../appointment-tool/components/apAnalytics';

const $ = jQuery;
const $replacementContainer = $('.js-qt-replacement');
const $allSteps = $replacementContainer.find('.js-qt-replacement--step');
const $appointmentTool = $('#appointment-tool');

/**
 * Replacement data
 * @type {{price: number, type: string, slug: string}}
 */
export let replacementData = {
    status: 'active',
    type: '',
    slug: '',
    price: 0,
    index: 0,
}

/**
 * Replacements
 * @param active {boolean}
 */
export function replacements(active) {
    if (!active) {
        $replacementContainer.slideUp(300);
        replacementData.status = 'inactive';
    } else {
        $replacementContainer.slideDown(300);
        replacementData.status = 'active';
    }
}

/**
 * Replacement module
 */
export function replacementModule() {
    changeSteps();

    if ($appointmentTool.length > 0) {
        submitReplacement();
    }
}

/**
 * Change steps
 */
function changeSteps() {
    $replacementContainer.on('click', '.js-qt-replacement--item', function () {
        const $option = $(this);

        if (!$option.hasClass('active')) {
            let $lastActiveStep = $allSteps.filter(':not(.hidden)').last();
            let lastActiveIndex = $lastActiveStep.data('index');
            let activeIndex = $option.closest('.js-qt-replacement--step').data('index');
            replacementData.index = activeIndex;

            if (activeIndex < lastActiveIndex) {
                const $stepsToHide = $allSteps.filter(`[data-index="${activeIndex}"]`).nextAll();
                $stepsToHide.find('.js-qt-replacement--item').removeClass('active');
                $stepsToHide.addClass('hidden');
            } else {
                if ($option.hasClass('next-step')) {
                    const $newActiveStep = $allSteps.filter(`[data-index="${activeIndex + 1}"]`);

                    if ($newActiveStep.hasClass('hidden')) {
                        $newActiveStep.removeClass('hidden');
                    }
                }
            }

            $option.siblings('.active').removeClass('active');
            $option.addClass('active')
            updateReplacementData();
            validateReplacement();
        }
    });
}

/**
 * Update replacement data
 */
function updateReplacementData() {
    const $activeOption = $replacementContainer.find('.js-qt-replacement--item.active').last();
    const price = $activeOption.data('price');
    const slug = $activeOption.data('slug');

    replacementData.type = $activeOption.data('type');
    replacementData.price = price && price > 0 ? price * tax : 0;
    replacementData.slug = slug !== 'default' ? slug.toUpperCase() : '';

    showReplacementInSidebar();
}

/**
 * Show replacement in sidebar
 */
function showReplacementInSidebar() {
    const $appointmentTool = $('#appointment-tool');
    const $sidebarReplacement = $('.js-tool-sidebar--replacement');
    const $sidebarReplacementItems = $sidebarReplacement.find('.js-tool-sidebar--items.replacement');
    let totalPrice;

    if ($appointmentTool.length > 0) {
        totalPrice = serviceSelectorData.totalPrice + replacementData.price;
    } else {
        let totalPriceFromServices = serviceDescriptionData.reduce((acc, service) => acc + service.price, 0);
		totalPrice = totalPriceFromServices + replacementData.price;
    }

    let price = replacementData.price;
    totalPrice = menaPrice(parseFloat(totalPrice));

    if (price) {
        price = parseFloat(price);
        price = menaPrice(price, false);
    } else {
        price = '';
    }

    if (replacementData.index === 2) {
        replacementData.type = `${$('.js-qt-replacement--step[data-index="1"] .js-qt-replacement--item.active').text()} - ${replacementData.type}`;
    }

    $sidebarReplacementItems.empty();
    $sidebarReplacementItems.append(
        $('<li>').addClass('tool-sidebar__flex').append(
            $('<span>').addClass('font-medium').text(replacementData.type),
            $('<span>').addClass('price').text(price),
        ),
    );

    $('.js-tool-sidebar--total').text(totalPrice);

    if ($sidebarReplacement.hasClass('hidden')) {
        $sidebarReplacement.removeClass('hidden');
        $sidebarReplacement.slideDown(300);
    }
}

/**
 * Remove replacement from sidebar
 */
function removeReplacementFromSidebar() {
    const totalPriceFromServices = serviceDescriptionData.reduce((acc, service) => acc + service.price, 0);
    const totalPrice = totalPriceFromServices - replacementData.price;
    const $sidebarReplacement = $('.js-tool-sidebar--replacement');

    if (!$sidebarReplacement.hasClass('hidden')) {
        $sidebarReplacement.slideUp(300, function () {
            $sidebarReplacement.find('.js-tool-sidebar--items.replacement').empty();
        }).addClass('hidden');
    }

    $('.js-tool-sidebar--total').text(`${totalPrice},00 ${currency}`);
}

/**
 * Submit replacement
 */
function submitReplacement() {
    $appointmentTool.on('click', '.js-ap-replacement--submit', function () {
        if (validateReplacement()) {
            apSwitchStep('user_info');
            apAnalytics('choose-replacement--submit', replacementData.slug);
            apAnalytics('personal-info--start');
        }
    });
}

/**
 * Validate replacement
 * @returns {boolean}
 */
function validateReplacement() {
    let valid = true;
    const $activeOption = $('.js-qt-replacement--item.active');
    const $submit = $('.js-ap-replacement--submit');

    if ($activeOption.length === 0) {
        if (!$submit.hasClass('c-button--disabled')) {
            $submit.addClass('c-button--disabled');
        }

        valid = false;
    } else {
        if ($submit.hasClass('c-button--disabled')) {
            $submit.removeClass('c-button--disabled');
        }
    }

    return valid;
}
